import React from "react";
import Animations from "../../utilities/Animations";
import ScreenHeading from "../../utilities/ScreenHead/ScreenHeading";
import netmed from "../../assests/project/netmed.gif";
import royal from "../../assests/project/royal.gif";
import blink from "../../assests/project/blink.gif";
import ScrollService from "../../utilities/ScrollService";
import "./project.css";

export const Project = (props) => {
  let fadeInScreenHand = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInscreen(props.id);
  };
  const fadeInSub = ScrollService.currScreenFadeIn.subscribe(fadeInScreenHand);
  return (
    <div id={props.id || ""}>
      <div className="scheading">
        <ScreenHeading
          title={"Projects"}
          subHeading={"Some good project here"}
        />
      </div>
      <div className="pParent">
        <div className="project">
          <div className="mProject">
            <div>
              <img className="imgP" src={netmed} alt="" />
            </div>
            <div>
              <p>CLONE OF NETMEDS</p>
              <div className="tech">
                <span>React | </span>
                <span>CSS | </span>
                <span>HTML</span>
              </div>
            </div>
            <div className="btnDiv">
              <div>
                <a
                  href="https://unrivaled-sprite-2be9c1.netlify.app/"
                  target="_blank"
                >
                  <button className="btnD">DEMO</button>
                </a>
              </div>
              <div>
                <a
                  href="https://github.com/gauravkrs/Netmeds-Clone"
                  target="_blank"
                >
                  <button className="btnD">CODE</button>
                </a>
              </div>
            </div>
          </div>

          <div className="mProject">
            <div>
              <img className="imgP" src={royal} alt="" />
            </div>
            <div>
              <p>CLONE OF ROYAL ENFIELD</p>
              <div className="tech">
                <span>Javascript | </span>
                <span>CSS |</span>
                <span> HTML</span>
              </div>
            </div>
            <div className="btnDiv">
              <div>
                <a href="https://royalenfieldclone.netlify.app" target="_blank">
                  <button className="btnD">DEMO</button>
                </a>
              </div>
              <div>
                <a
                  href="https://github.com/gauravkrs/Royal-Enfield"
                  target="_blank"
                >
                  <button className="btnD">CODE</button>
                </a>
              </div>
            </div>
          </div>
          
          <div className="mProject">
            <div>
              <img className="imgP" src={blink} alt="" />
            </div>
            <div>
              <p>CLONE OF BLINKIT</p>
              <div className="tech">
                <span>Javascript | </span>
                <span>CSS |</span>
                <span> HTML</span>
              </div>
              <div>
                <p></p>
              </div>
            </div>
            <div className="btnDiv">
              <div>
                <a
                  href="https://blink-it-by-arshad-gaurav-ayush-rohit-shubham.netlify.app/"
                  target="_blank"
                >
                  <button className="btnD">DEMO</button>
                </a>
              </div>
              <div>
                <a href="https://github.com/gauravkrs/blinkit" target="_blank">
                  <button className="btnD">CODE</button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
